module.exports = __webpack_public_path__ + "img/kn.2ea58490.svg";